function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Paginator } from '@domain-group/fe-blueprint-ui/pagination';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { BodySection, PageContainer } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesListingNoSearchResults from '../allhomes-listing-no-search-results';
import Agencies from '../agency-list';
import AppraisalCta from '../appraisal-cta';
import StickySidebox from '../sticky-sidebox';
import { buildUrlFromLocalities } from '../../utils/build-url';
import useAgenciesInLocalities from '../../utils/use-agencies-in-localities';
import insertFluidAds from '../../utils/insert-fluid-ads';
import * as styles from './allhomes-listing-list-search-results-sold.style';
import { WrappedListingCard } from '../wrapped-listing-card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ListSearchResultsSold = props => {
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var _props$media = props.media,
    desktop = _props$media.desktop,
    tablet = _props$media.tablet,
    mobile = _props$media.mobile;
  var localities = props.filters.getLocalities();
  var agencyResult = useAgenciesInLocalities({
    localities
  });
  var localityName = localities.length && (localities.length > 1 ? "".concat(localities.length, " locations") : localities[0].name);
  var agencySearchSlug = localities.length && (localities.length > 1 ? buildUrlFromLocalities(localities) : "".concat(localities[0].slug, "/"));
  var getCardAppearance = () => desktop ? 'horizontal' : 'vertical';
  var getListing = result => ___EmotionJSX("div", {
    css: styles.row(),
    key: "listing-".concat(result.listing.id)
  }, ___EmotionJSX(WrappedListingCard, _extends({
    appearance: getCardAppearance(),
    css: styles.item,
    onAddToWatchlist: props.onAddToWatchlist
  }, result)));
  var showFluidAds = mobile && !props.inlineAdsDisabled;
  var listingList = props.searchResults.map(getListing);
  var listingListWithAds = showFluidAds ? insertFluidAds(listingList, {
    adRowStyle: styles.row({
      isAd: true,
      isFluid: true
    })
  }) : listingList;
  listingListWithAds = [listingListWithAds.slice(0, 3), agencyResult && ___EmotionJSX(Agencies, {
    localityName: localityName,
    agencySearchSlug: agencySearchSlug,
    agencyList: agencyResult,
    enquiryEndpoint: props.enquiryEndpoint
  }), listingListWithAds.slice(3)];
  return ___EmotionJSX(PageContainer, {
    css: styles.pageContainer
  }, ___EmotionJSX(BodySection, null, ___EmotionJSX("div", {
    css: styles.searchContent({
      hasNoResult: isEmpty(props.searchResults),
      hasSingleFeaturedProperty: mobile && props.featuredProperties.length === 1
    })
  }, ___EmotionJSX("div", {
    css: styles.left
  }, !isEmpty(props.searchResults) && ___EmotionJSX("div", {
    css: styles.items({
      hasSingleFeaturedProperty: mobile && props.featuredProperties.length === 1
    })
  }, listingListWithAds), isEmpty(props.searchResults) && ___EmotionJSX(Fragment, null, ___EmotionJSX(AllhomesListingNoSearchResults, {
    media: props.media,
    isDefaultSearch: props.isDefaultSearch,
    propertiesOfTheWeek: isEmpty(props.featuredProperties) ? props.propertiesOfTheWeek : [],
    onClearFilter: props.onClearFilter,
    onPropertyAlertClick: props.onPropertyAlertClick
  }), agencyResult && ___EmotionJSX(Agencies, {
    localityName: localityName,
    agencySearchSlug: agencySearchSlug,
    agencyList: agencyResult,
    enquiryEndpoint: props.enquiryEndpoint
  })), props.totalPages > 1 && ___EmotionJSX(Paginator, {
    currentPage: props.currentPage,
    totalPages: props.totalPages,
    urlTemplate: getAbsoluteUrl(props.paginatorUrlTemplate),
    onPageChange: props.onPageChange
  })), (desktop || tablet) && ___EmotionJSX(StickySidebox, {
    css: styles.right
  }, (agencyResult === null || agencyResult === void 0 ? void 0 : agencyResult.count) > 0 && ___EmotionJSX(AppraisalCta, {
    enquiryEndpoint: props.enquiryEndpoint,
    filters: props.filters
  })))));
};
ListSearchResultsSold.propTypes = {
  media: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  searchResults: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  inlineAdsDisabled: PropTypes.bool,
  isDefaultSearch: PropTypes.bool.isRequired,
  featuredProperties: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  propertiesOfTheWeek: PropTypes.arrayOf(PropTypes.shape({})),
  onAddToWatchlist: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  onPropertyAlertClick: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  paginatorUrlTemplate: PropTypes.string.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onInlineAdClick: PropTypes.func,
  filters: PropTypes.shape({
    getLocalities: PropTypes.func
  }).isRequired,
  enquiryEndpoint: PropTypes.string.isRequired
};
ListSearchResultsSold.defaultProps = {
  searchResults: [],
  inlineAdsDisabled: false,
  currentPage: 1,
  totalPages: 1,
  featuredProperties: [],
  propertiesOfTheWeek: [],
  onInlineAdClick: () => {}
};
export default ListSearchResultsSold;